/**
 * AdminLayout — админ-панель (структура как UCP/Shop: logo слева, ссылки справа).
 */

import React, { useCallback, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import AdminMenu from "../menus/AdminMenu";

const AdminLayout = ({ children }) => {
    const { pathname } = useLocation();
    const [openBurgerFn, setOpenBurgerFn] = useState(null);

    const handleSetOpenBurger = useCallback((openFn) => {
        setOpenBurgerFn(() => openFn);
    }, []);

    const isApplicationsSection =
        pathname === "/acp" ||
        pathname === "/acp/" ||
        pathname.startsWith("/acp/check-characters");

    return (
        <div className="app-container app-container--admin">
            <div className="main-container">
                <header className="admin-header">
                    <div className="admin-header-left">
                        <button
                            type="button"
                            className="burger-button admin-burger-button"
                            onClick={() => openBurgerFn && openBurgerFn()}
                            aria-label="Меню"
                        >
                            <div></div>
                        </button>
                        <AdminMenu onTrigger={handleSetOpenBurger} />
                        <div className="logo-container admin-logo-block">
                            <Link to="/acp">
                                <img
                                    src="/media/logo_medieval.png"
                                    alt="Logo"
                                />
                            </Link>
                            <div>
                                <span className="logo-container-title logo-container-title--gold">
                                    Medieval
                                </span>
                                <span className="logo-container-title">
                                    Roleplay
                                </span>
                            </div>
                        </div>
                    </div>

                    <nav className="admin-header-links" aria-label="Админ-меню">
                        <a
                            href="https://api.medieval-rp.net/"
                            target="_blank"
                            rel="noreferrer"
                        >
                            <span className="admin-header-link">ЛОГИ</span>
                        </a>
                        <Link to="/acp/check-characters">
                            <span
                                className={`admin-header-link ${isApplicationsSection ? "active" : ""}`}
                            >
                                ПРОВЕРКА ЗАЯВОК
                            </span>
                        </Link>
                        <span className="admin-header-link admin-header-link--muted">
                            АДМИНИСТРАТОРЫ
                        </span>
                        <span className="admin-header-link admin-header-link--muted">
                            ВЫДАЧА
                        </span>
                        <span className="admin-header-link admin-header-link--muted">
                            БЛОКИРОВКИ
                        </span>
                        <Link to="/ucp">
                            <span className="admin-header-link">ВЫХОД</span>
                        </Link>
                    </nav>
                </header>

                <main>{children}</main>
            </div>
        </div>
    );
};

export default AdminLayout;
